import { useStore } from 'store';
import getFilesSchema from './getFilesSchema';

export default function useFilesSchema() {
  return useStore(getFilesSchema);
}
